import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import logo from './logo.svg';
import './App.css';
import { BrowserRouter,Routes,Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Booking from "./pages/Booking";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Shop from "./pages/Shop";
import Checkout from "./pages/Checkout";
import AuthProvider from "./Context/AuthContext";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AdminDashboard from "./pages/AdminDashboard";
import UserTable from "./pages/UserTable";
import ContactUsTable from "./pages/ContactUsTable";
import BookingTable from "./pages/BookingTable";
import ViewPage from "./pages/ViewPage";
import UserView from "./pages/UserView";
import ViewPageBooking from "./pages/ViewPageBooking";
import MyBookingDetails from "./pages/MyBookingDetails";
import MyBookDetailView from "./pages/MyBookDetailView";
import BookService from "./pages/BookService";
function App() {
  return (
    <BrowserRouter>
    <AuthProvider>
    <Header/>
      <Routes>
        <Route path="/" element = {<Home/>}/>
        <Route path="contact/" element = {<Contact/>}/>
        <Route path="about/" element = {<About/>}/>
        <Route path="service/" element = {<Services/>}/>
        <Route path="booking/" element = {<Booking/>}/>
        <Route path="login/" element = {<Login/>}/>
        <Route path="register/" element = {<Register/>}/>
        <Route path="shop/" element = {<Shop/>}/>
        <Route path="/book/:serviceId" element = {<BookService/>}/>
        <Route path="/checkout/:id" element = {<Checkout/>}/>
        <Route path="/AdminDashboard" element = {<AdminDashboard/>}/>
        <Route path="/UserTable" element = {<UserTable/>}/>
        <Route path="/ContactUsTable" element = {<ContactUsTable/>}/>
        <Route path="/BookingTable" element = {<BookingTable/>}/>
        <Route path="/MyBookingDetails" element = {<MyBookingDetails/>}/>
        <Route path="/MyBookDetailView/:id" element = {<MyBookDetailView/>}/>
        <Route path="/ViewPage/:id" element = {<ViewPage/>}/>
        <Route path="/UserView/:id" element = {<UserView/>}/>
        <Route path="/ViewPageBooking/:id" element = {<ViewPageBooking/>}/>
        <Route path="*" element = {<Home/>}/>
      </Routes>
      <Footer/>
      </AuthProvider>
      <ToastContainer/>
    </BrowserRouter>
  );
}

export default App;
